<div class="bottom-sheet_sheet">
	<ng-content></ng-content>
</div>
